module.exports = __webpack_public_path__ + "img/metal_n@2x.866eb20e.png";